import theme from 'config/theme';

export default {
  vehiclesNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    minWidth: '32px',
    minHeight: '32px',
    borderRadius: '50%',
    backgroundColor: theme.palette.blues.primaryBlue200,
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: 1,
    color: theme.palette.grays.gray900,
  },
  secondaryText: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.blues.primaryBlue700,
    lineHeight: 1,
  },
  taskSection: {
    marginTop: 0,
  },
  removeButton: {
    marginTop: '24px',
  },
};
